// extracted by mini-css-extract-plugin
export var createdDate = "_jr-1";
export var divider = "_jr-2";
export var headerDivider = "_jr-3";
export var messagesCard = "_jr-0";
export var messagesContainer = "_jr-7";
export var messagesContainerWrapper = "_jr-4";
export var pointerCapturingButtonBoxes = "_jr-a";
export var showLeftPanelButton = "_jr-9";
export var showMoreButton = "_jr-c";
export var showMoreButtonContainer = "_jr-b";
export var summaryTitle = "_jr-6";
export var systemMessageCardWrapper = "_jr-d";
export var topButtons = "_jr-8";
export var withPadding = "_jr-5";